export const echoStyObj = {
  '--fg-themes-brand-subtle': 'rgba(255, 164, 51, 1)',
  '--fg-themes-brand-default': 'rgba(115, 52, 6, 1)',
  '--fg-themes-brand-default_disable': 'rgba(255, 185, 77, 1)',
  '--fg-themes-brand-inverse': 'rgba(255, 229, 173, 1)',
  '--fg-themes-brand-invere_disable': 'rgba(204, 107, 29, 1)',
  '--fg-themes-success-subtle': 'rgba(95, 232, 120, 1)',
  '--fg-themes-success-default': 'rgba(18, 111, 70, 1)',
  '--fg-themes-success-default_disable': 'rgba(134, 241, 143, 1)',
  '--fg-themes-success-inverse': 'rgba(199, 252, 193, 1)',
  '--fg-themes-success-inverse_disable': 'rgba(47, 167, 92, 1)',
  '--fg-themes-warning-subtle': 'rgba(255, 228, 28, 1)',
  '--fg-themes-warning-default': 'rgba(122, 102, 5, 1)',
  '--fg-themes-warning-default_disable': 'rgba(255, 236, 84, 1)',
  '--fg-themes-warning-inverse': 'rgba(255, 247, 164, 1)',
  '--fg-themes-warning-inverse_disable': 'rgba(183, 159, 14, 1)',
  '--fg-themes-danger-subtle': 'rgba(255, 81, 113, 1)',
  '--fg-themes-danger-default': 'rgba(122, 15, 75, 1)',
  '--fg-themes-danger-default_disable': 'rgba(255, 124, 136, 1)',
  '--fg-themes-danger-inverse': 'rgba(255, 192, 185, 1)',
  '--fg-themes-danger-inverse_disable': 'rgba(183, 40, 94, 1)',
  '--fg-themes-info-subtle': 'rgba(44, 184, 244, 1)',
  '--fg-themes-info-default': 'rgba(8, 55, 117, 1)',
  '--fg-themes-info-default_disable': 'rgba(95, 212, 248, 1)',
  '--fg-themes-info-inverse': 'rgba(170, 245, 253, 1)',
  '--fg-themes-info-inverse_disable': 'rgba(22, 109, 175, 1)',
  '--border-themes-brand-default': 'rgba(255, 185, 77, 1)',
  '--border-themes-success-default': 'rgba(134, 241, 143, 1)',
  '--border-themes-warning-default': 'rgba(255, 236, 84, 1)',
  '--border-themes-danger-default': 'rgba(255, 124, 136, 1)',
  '--border-themes-info-default': 'rgba(95, 212, 248, 1)',
  '--bg-themes-brand-subtle-default': 'rgba(255, 244, 214, 1)',
  '--bg-themes-brand-subtle-pressed': 'rgba(255, 229, 173, 1)',
  '--bg-themes-brand-subtle-selected': 'rgba(255, 185, 77, 1)',
  '--bg-themes-brand-regular-default': 'rgba(255, 164, 51, 1)',
  '--bg-themes-brand-regular-preese': 'rgba(232, 134, 44, 1)',
  '--bg-themes-success-subtle-default': 'rgba(229, 253, 223, 1)',
  '--bg-themes-success-subtle-pressed': 'rgba(199, 252, 193, 1)',
  '--bg-themes-success-regular-default': 'rgba(95, 232, 120, 1)',
  '--bg-themes-warning-subtle-default': 'rgba(255, 251, 209, 1)',
  '--bg-themes-warning-subtle-pressed': 'rgba(255, 247, 164, 1)',
  '--bg-themes-warning-regular-default': 'rgba(255, 228, 28, 1)',
  '--bg-themes-danger-subtle-default': 'rgba(255, 226, 220, 1)',
  '--bg-themes-danger-subtle-pressed': 'rgba(255, 192, 185, 1)',
  '--bg-themes-danger-regular-default': 'rgba(255, 81, 113, 1)',
  '--bg-themes-info-subtle-default': 'rgba(212, 253, 254, 1)',
  '--bg-themes-info-subtle-pressed': 'rgba(170, 245, 253, 1)',
  '--bg-themes-info-regular-default': 'rgba(44, 184, 244, 1)',
}